// import React, { useState } from 'react';
// import './login.css';
// import image from '../images/user.png';
// import { useNavigate } from 'react-router-dom';
// import { useAuth } from '../AuthContext';

// const Login = () => {
//   const [username, setUsername] = useState('');
//   const [password, setPassword] = useState('');
//   const [error, setError] = useState('');
//   const { login } = useAuth();
//   const navigate = useNavigate(); 

//   const handleLogin = async (event) => {

//     event.preventDefault();
  
//     try {
//       // const response = await fetch(`https://invoice.dockyardsoftware.com/api/User/authentication`, {
//       //   method: 'POST',
//       //   headers: {
//       //     'Content-Type': 'application/json'
//       //   },

//       const response = await fetch('https://invoice.dockyardsoftware.com/api/User/authentication', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json'
//         },
//         body: JSON.stringify({
//           username: username,
//           password: password 
//         })
//       });
  
//       if (!response.ok) {
//         throw new Error('Invalid credentials');
//       }
  
//       const userData = await response.json();
      
      
//       login(userData.username, parseInt(userData.userID), parseInt(userData.companyID)); 
      
//       console.log('UserID:', userData.userID);
//       console.log('CompanyID:', userData.companyID);
//       navigate('/form'); 
  
//     } catch (error) {
//       setError('Invalid username or password');
//       console.error('Login error:', error);
//     }
//   };
  
//   return (
//     <div className="login-container">
//       <div className="login-box">
//         <div className="icon-container">
//           <img src={image} alt="Login Icon" className="login-icon" />
//         </div>
//         <form onSubmit={handleLogin}>
//           <div className="input-group">
//             <label htmlFor="username">Username:</label>
//             <input 
//               type="text" 
//               id="username" 
//               value={username} 
//               onChange={(e) => setUsername(e.target.value)} 
//               required 
//             />
//           </div>
//           <div className="input-group">
//             <label htmlFor="password">Password:</label>
//             <input 
//               type="password" 
//               id="password" 
//               value={password} 
//               onChange={(e) => setPassword(e.target.value)} 
//               required 
//             />
//           </div>
//           {error && <p className="error-message">{error}</p>}
//           <button type="submit" className="login-button">Login</button>
//         </form>
//         <div className="register-link">
//           <p>Not registered? <a href="/register">Register here</a></p>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Login;



//Add a Particles in login screen

// import React, { useState } from 'react';
// import './login.css';
// import image from '../images/user.png';
// import { useNavigate } from 'react-router-dom';
// import { useAuth } from '../AuthContext';
// import ParticleBackground from './ParticlesBackground';
// import bg from '../images/bg.png'

// const Login = () => {
//   const [username, setUsername] = useState('');
//   const [password, setPassword] = useState('');
//   const [error, setError] = useState('');
//   const [isLoading, setIsLoading] = useState(false);
//   const { login } = useAuth();
//   const navigate = useNavigate();

//   const handleLogin = async (event) => {
//     event.preventDefault();
//     setIsLoading(true);
//     setError('');
    
//     try {
//       const response = await fetch('https://invoice.dockyardsoftware.com/api/User/authentication', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json'
//         },
//         body: JSON.stringify({
//           username: username,
//           password: password 
//         })
//       });
  
//       if (!response.ok) {
//         throw new Error('Invalid credentials');
//       }
  
//       const userData = await response.json();
//       login(userData.username, parseInt(userData.userID), parseInt(userData.companyID)); 
//       navigate('/form');
  
//     } catch (error) {
//       setError('Invalid username or password');
//       console.error('Login error:', error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return (
//     <div className="login-page">
//       <ParticleBackground />
//       <div className="login-container">
//         <div className="login-box">
//           <div className="icon-container">
//             <img src={image} alt="Login Icon" className="login-icon" />
//             <h2 className="login-title">Welcome Back</h2>
//           </div>
//           <form onSubmit={handleLogin} className="login-form">
//             <div className="input-group">
//               <label htmlFor="username"><strong>Username</strong></label>
//               <input 
//                 type="text" 
//                 id="username" 
//                 value={username} 
//                 onChange={(e) => setUsername(e.target.value)} 
//                 required 
//                 disabled={isLoading}
//                 placeholder="Enter your username"
//               />
//             </div>
//             <div className="input-group">
//               <label htmlFor="password"><strong>Password</strong></label>
//               <input 
//                 type="password" 
//                 id="password" 
//                 value={password} 
//                 onChange={(e) => setPassword(e.target.value)} 
//                 required 
//                 disabled={isLoading}
//                 placeholder="Enter your password"
//               />
//             </div>
//             {error && <div className="error-message" role="alert">{error}</div>}
//             <button type="submit" className="login-button" disabled={isLoading}>
//               {isLoading ? 'Signing In...' : 'Sign In'}
//             </button>
//           </form>
//           <div className="register-link">
//             <p>Don't have an account? <a href="/register">Create one</a></p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Login;


//Add a dollar coin particles in login screen
import React, { useState } from 'react';
import './login.css';
import image from '../images/user.png';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import ParticleBackground from './ParticlesBackground';
import bg from '../images/bg.png';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    setError('');
    
    try {
      const response = await fetch('https://invoice.dockyardsoftware.com/api/User/authentication', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          username: username,
          password: password 
        })
      });
  
      if (!response.ok) {
        throw new Error('Invalid credentials');
      }
  
      const userData = await response.json();
      login(userData.username, parseInt(userData.userID), parseInt(userData.companyID)); 
      navigate('/form');
  
    } catch (error) {
      setError('Invalid username or password');
      console.error('Login error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page" style={{ backgroundImage: `url(${bg})` }}>
      <ParticleBackground />
      <div className="login-container">
        <div className="login-box">
          <div className="icon-container">
            <img src={image} alt="Login Icon" className="login-icon" />
            <h2 className="login-title">Welcome Back</h2>
          </div>
          <form onSubmit={handleLogin} className="login-form">
            <div className="input-group">
              <label htmlFor="username"><strong>Username</strong></label>
              <input 
                type="text" 
                id="username" 
                value={username} 
                onChange={(e) => setUsername(e.target.value)} 
                required 
                disabled={isLoading}
                placeholder="Enter your username"
              />
            </div>
            <div className="input-group">
              <label htmlFor="password"><strong>Password</strong></label>
              <input 
                type="password" 
                id="password" 
                value={password} 
                onChange={(e) => setPassword(e.target.value)} 
                required 
                disabled={isLoading}
                placeholder="Enter your password"
              />
            </div>
            {error && <div className="error-message" role="alert">{error}</div>}
            <button type="submit" className="login-button" disabled={isLoading}>
              {isLoading ? 'Signing In...' : 'Sign In'}
            </button>
          </form>
          <div className="register-link">
            <p>Don't have an account? <a href="/register">Create one</a></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;